<template>
    <v-app>
        <!--pm-app-main-toolbar /-->
        <pm-app-navigation-drawer :key="$store.state.language" />
        <slot name="default">
            <!--keep-alive :include="['pm-patient-list','pm-calendar']">
                <router-view ref="component" :key="$route.fullPath"></router-view>
            </keep-alive-->
        </slot>

        <pm-app-notification v-model="notification" />
        <pm-app-snackbar />
        <pm-app-progress />
        <slot name="addons"></slot>
    </v-app>
</template>

<script>
import PmAppCoreMixin from '../../extensions/mixins/mixin-app-core';

export default {
    name: "App",
    components: {
    },
    mixins: [
        PmAppCoreMixin,
    ],
    data: function() {
        return ({
            reportBug: false,
            help: 0,
            debug: true,
            debugMsg: '',
            buttonBarItems: [],
            externalUrlDialog: false,
            externalUrl: null,
            //customerServiceDialog: false,
        });
    },
    created: function () {
        if (!this.debug) {
            console.warn('The developer console is disabled.');
            window.console.trace = window.console.dir = window.console.log = function () {
                console.warn('The developer console is disabled.');
            };
        }

        this.$bus.$on('app.showHelp', () => {
            this.$store.state.app.drawer = false;
            this.help = 1;
        });
        this.$bus.$on('app.showBugReporter', () => {
            this.$store.state.app.drawer = false;
            this.reportBug = 1;
        });
        this.$bus.$on('language-changed', (language) => {
            this.$root.setLocale(language);
        });
        this.$bus.$on('currency-changed', (currency) => {
            this.$root.setCurrency(currency);
        });

        if(typeof window.NetworkStatusHandler !== 'undefined') NetworkStatusHandler.init();
    },
};
</script>
